export default class AppConfig {
  static masterAuthUrl = process.env.VUE_APP_MASTERAUTH_API_URL || `${window.location.origin}/`;
}
